var _path;
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
class IconFullScreenLine extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
      name: "IconFullScreen",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef
    }), _path || (_path = /*#__PURE__*/React.createElement("path", {
      d: "M1158.513-.012v123.68h550.5L123.68 1708.878V1158.5H0V1920h761.5v-123.68H211.121l1585.21-1585.21v550.5h123.68V-.011z",
      fillRule: "evenodd"
    })));
  }
}
IconFullScreenLine.glyphName = 'full-screen';
IconFullScreenLine.variant = 'Line';
IconFullScreenLine.displayName = 'IconFullScreenLine';
// eslint-disable-next-line react/forbid-foreign-prop-types
IconFullScreenLine.propTypes = {
  ...SVGIcon.propTypes
};
IconFullScreenLine.allowedProps = [...SVGIcon.allowedProps];
export default IconFullScreenLine;
export { IconFullScreenLine };